import script from "./UiPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./UiPagination.vue?vue&type=script&setup=true&lang=js"

import "./UiPagination.vue?vue&type=style&index=0&id=2f2a9e3f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2a9e3f"]])

export default __exports__